export enum StorageId {
  IdToken = 'id_token',
}
